var _rect, _rect2, _path, _path2, _path3, _g, _circle, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47202_6210)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1.0221,
    transform: "matrix(-1 0 0 1 63 17.6665)",
    fill: "#4B4FE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1.0221,
    transform: "matrix(-1 0 0 1 113 38.333)",
    fill: "#0EC38B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.921 91.8957C74.6056 93.7902 85.0065 92.1031 93.9738 86.3626C108.891 76.8134 115.283 58.9655 110.978 42.7163",
    stroke: "url(#paint0_linear_47202_6210)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeDasharray: "0.6 3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4611 16.5207C21.3974 16.8947 16.785 22.1133 17.159 28.1769C19.7554 70.2815 53.7169 103.881 95.9739 105.904C102.042 106.194 107.197 101.51 107.487 95.4422C107.778 89.374 103.094 84.2193 97.0257 83.9289C65.992 82.4435 41.024 57.7438 39.1172 26.8228C38.7433 20.7592 33.5247 16.1468 27.4611 16.5207Z",
    fill: "url(#paint1_linear_47202_6210)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47202_6210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 16,
    width: 91,
    height: 90
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4841 16.895C21.6272 17.2562 17.1721 22.2969 17.5333 28.1538C20.118 70.0678 53.9261 103.516 95.9918 105.529C101.853 105.81 106.832 101.286 107.113 95.4243C107.393 89.563 102.869 84.584 97.0077 84.3034C65.7828 82.8089 40.6615 57.9575 38.743 26.8459C38.3818 20.989 33.341 16.5338 27.4841 16.895Z",
    stroke: "url(#paint2_linear_47202_6210)",
    strokeWidth: 0.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47202_6210)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_47202_6210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 1.0221,
    transform: "matrix(-1 0 0 1 46 16)",
    fill: "#4B4FE2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_47202_6210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 1.0221,
    transform: "matrix(-1 0 0 1 73 66)",
    fill: "#FF7C66"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 34 83)",
    fill: "url(#paint3_linear_47202_6210)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1.0221,
    transform: "matrix(-1 0 0 1 74.9995 57.667)",
    fill: "#FF7C66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_47202_6210",
    x: 19,
    y: 7,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_47202_6210"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_47202_6210",
    x: 51,
    y: 58,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_47202_6210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47202_6210",
    x1: 92.7222,
    y1: 87.1055,
    x2: 110.942,
    y2: 41.8634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0782194,
    stopColor: "#0EC38B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#0EC38B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47202_6210",
    x1: 103.521,
    y1: 105.88,
    x2: 48.52,
    y2: 7.88285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332905,
    stopColor: "#8395AA",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8395AA",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47202_6210",
    x1: 67.5,
    y1: 67,
    x2: 47,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8395AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956317,
    stopColor: "#8395AA",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47202_6210",
    x1: 20.5,
    y1: 24,
    x2: 0.800264,
    y2: 2.92583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.263689,
    stopColor: "#8395AA",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8395AA",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47202_6210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "matrix(-1 0 0 1 120 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/No_result.a8a6b6ad4c4c8d84fd0a3c6e6c7e42cf.svg";
export { ForwardRef as ReactComponent };